/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseCHOpenIcon20Regular = forwardRef('ArrowCollapseCHOpenIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M2.742 11.803a2.55 2.55 0 0 1 0-3.606L6.72 4.22a.75.75 0 0 1 1.06 1.06L3.803 9.258a1.05 1.05 0 0 0 0 1.485L7.78 14.72a.75.75 0 1 1-1.06 1.06l-3.978-3.977Z" }),
        React.createElement("path", { d: "M17.258 11.803a2.55 2.55 0 0 0 0-3.606L13.28 4.22a.75.75 0 0 0-1.06 1.06l3.977 3.978c.41.41.41 1.074 0 1.485L12.22 14.72a.75.75 0 1 0 1.06 1.06l3.978-3.977Z" })));
});
